import type { FeatureFlags, OasDocument3XExtended } from '@ipfabric/utils';
import OpenAPIParser from '@readme/openapi-parser';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { handleInitialAppRequest } from 'components/GlobalState/commands/handleInitialAppRequest';

import { loadFeatureFlags } from '@ipfabric/ui-components/utils/featureFlags';

export const loadInitialAppData: GlobalStateCommandFactory =
  (cmdContext, dispatch) => async () => {
    await dispatch(handleInitialAppRequest, async () => {
      const [oas, featureFlags] = await Promise.all([
        cmdContext.api.request<OasDocument3XExtended>({
          url: '/static/oas/openapi-internal.json',
        }),
        cmdContext.api.request<Partial<FeatureFlags>>({
          url: '/os/feature-flags',
        }),
      ]);
      loadFeatureFlags(featureFlags);

      // dereference the oas components
      const dereferencedOas = (await OpenAPIParser.dereference(
        oas,
      )) as OasDocument3XExtended;

      cmdContext.updateState((draft) => {
        draft.oas = dereferencedOas;
      });
    });
  };
